const { populate } = require('@/functions/objects');
const { toDate } = require('@/functions/transform');
const { toString } = require('../../functions/transform');

class Reservation {
    constructor(data = {}) {
        /**
         * @type {string}
         */
        this.token = '';

        /**
         * @type {Date}
         */
        this.expiresAt = null;

        /**
         * @type {string}
         */
        this.thirdPartyRef = '';

        populate(this, data);
    }

    getHydrationMap() {
        return {
            expiresAt: toDate,
            thirdPartyRef: toString,
            token: toString,
        };
    }
}

module.exports = Reservation;
